import React from 'react';
import { Modal, Space, Typography, Button, Divider, Image } from 'antd';
import { FileTextOutlined, PrinterOutlined, FilePdfOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

const { Title, Text } = Typography;

const calcularMatematicas = (doc) => {
    if (!doc) return { subtotal: 0, descuento: 0, total: 0 };
    let sumaDescuentos = 0; let sumaSubtotal = 0;
    (doc.items || []).forEach(item => {
        const precioBase = Number(item.precio_unitario) || 0;
        const cantidad = Number(item.cantidad) || 1;
        const porcentajeDescuento = Number(item.descuento) || 0;
        sumaSubtotal += (precioBase * cantidad);
        sumaDescuentos += ((precioBase * cantidad) * (porcentajeDescuento / 100));
    });
    return { subtotal: sumaSubtotal, descuento: Math.round(sumaDescuentos), total: doc.total };
};

const ModalDetalleDocumento = ({
    visible,
    onClose,
    documento,
    onImprimir,
    onDescargarPDF
}) => {
    if (!documento) return null;

    const m = calcularMatematicas(documento);
    const esVenta = documento.tituloDocumento === 'FACTURA DE VENTA';

    // Lógica para no mostrar el documento si es consumidor final
    const nombreCompleto = `${documento.cliente_nombre || ''} ${documento.cliente_apellidos || ''}`.trim();
    const nombreCliente = nombreCompleto ? nombreCompleto.toUpperCase() : 'CONSUMIDOR FINAL';
    const docCliente = documento.cliente_documento || '222222222222';
    const mostrarDoc = !(nombreCliente === 'CONSUMIDOR FINAL' && docCliente === '222222222222');

    return (
        <Modal
            title={<Space><FileTextOutlined style={{ color: '#22BABB' }} /><Text strong>{documento.tituloDocumento || 'DETALLE DE VENTA'}</Text></Space>}
            open={visible}
            onCancel={onClose}
            width={400}
            centered
            footer={[
                <Button key="pdf" icon={<FilePdfOutlined />} onClick={() => onDescargarPDF(documento, esVenta ? 'venta' : 'nota')} style={{ height: '45px', fontWeight: 'bold', borderRadius: '8px', color: '#d32f2f', borderColor: '#d32f2f' }}>
                    PDF
                </Button>,
                <Button key="print" type="primary" icon={<PrinterOutlined />} onClick={() => onImprimir(documento)} style={{ background: '#22BABB', height: '45px', fontWeight: 'bold', borderRadius: '8px', border: 'none' }}>
                    IMPRIMIR TIRILLA
                </Button>
            ]}
            styles={{ body: { padding: 0 } }}
        >
            <div style={{ padding: '25px', backgroundColor: '#fff', fontFamily: 'monospace', height: 'calc(100vh - 125px)', overflowY: 'auto' }}>
                <style>{`
                    .ticket-scroll::-webkit-scrollbar { width: 4px; }
                    .ticket-scroll::-webkit-scrollbar-thumb { background-color: #cbd5e1; border-radius: 4px; }
                `}</style>

                <div style={{ textAlign: 'center', marginBottom: 15 }}>
                    <Title level={5} style={{ margin: 0 }}>
                        {documento.numero_factura ? `${esVenta ? 'RECIBO' : 'NOTA'} #${documento.numero_factura}` : 'TICKET'}
                    </Title>
                    <Text style={{ fontSize: '11px' }}>
                        {dayjs(documento.fecha).format('DD/MM/YYYY, hh:mm A')}
                    </Text>
                </div>

                <Divider dashed style={{ margin: '10px 0' }} />

                <div style={{ fontSize: '12px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Text>CAJERO:</Text>
                        <Text>{documento.cajero_nombre?.toUpperCase()} {documento.cajero_apellidos?.toUpperCase()}</Text>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Text>CLIENTE:</Text>
                        <Text>{nombreCliente}</Text>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Text>CC/NIT:</Text>
                        <Text>{docCliente}</Text>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Text>MEDIO DE PAGO:</Text>
                        <Text>{documento.metodo_pago?.toUpperCase()}</Text>
                    </div>
                </div>

                <Divider dashed style={{ margin: '10px 0' }} />

                <div className="ticket-scroll" style={{ marginBottom: 15, maxHeight: '220px', overflowY: 'auto', paddingRight: '8px' }}>
                    {documento.items?.map((item, i) => (
                        <div key={i} style={{ marginBottom: 8, fontSize: '12px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <span style={{ flex: 1 }}>{item.nombre?.toUpperCase()}</span>
                                <Text strong>${Number(item.subtotal).toLocaleString('es-CO')}</Text>
                            </div>
                            <div style={{ fontSize: '11px', color: '#666' }}>
                                {item.cantidad} UND x ${Number(item.precio_unitario).toLocaleString('es-CO')}
                            </div>
                        </div>
                    ))}
                </div>

                <Divider dashed style={{ margin: '10px 0' }} />

                <div style={{ fontSize: '13px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Text>SUBTOTAL:</Text>
                        <Text>${m.subtotal.toLocaleString('es-CO')}</Text>
                    </div>
                    {m.descuento > 0 && (
                        <div style={{ display: 'flex', justifyContent: 'space-between', color: '#16a34a' }}>
                            <Text>DESCUENTO:</Text>
                            <Text>-${m.descuento.toLocaleString('es-CO')}</Text>
                        </div>
                    )}

                    <div style={{
                        display: 'flex', justifyContent: 'space-between',
                        fontSize: documento.metodo_pago === 'Credito' ? '15px' : '18px',
                        fontWeight: 'bold', marginTop: 5
                    }}>
                        <span>TOTAL {esVenta ? 'VENTA' : 'DEVUELTO'}:</span>
                        <span>${Number(documento.total).toLocaleString('es-CO')}</span>
                    </div>
                </div>

                <Divider dashed style={{ margin: '10px 0' }} />

                <div style={{ background: '#f8fafc', padding: '10px', borderRadius: '4px', fontSize: '11px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Text strong>MÉTODO:</Text>
                        <Text>{documento.metodo_pago?.toUpperCase()}</Text>
                    </div>

                    {esVenta && documento.metodo_pago?.toLowerCase() === 'efectivo' && (
                        <>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Text>RECIBIDO:</Text>
                                <Text>${Number(documento.efectivo_recibido || 0).toLocaleString('es-CO')}</Text>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Text>CAMBIO:</Text>
                                <Text strong>${Number(documento.cambio_entregado || 0).toLocaleString('es-CO')}</Text>
                            </div>
                        </>
                    )}

                    {esVenta && documento.metodo_pago?.toLowerCase() === 'mixto' && (
                        <>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Text>EFECTIVO:</Text>
                                <Text>${Number(documento.monto_efectivo || 0).toLocaleString('es-CO')}</Text>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Text>TRANSF.:</Text>
                                <Text>${Number(documento.monto_transferencia || 0).toLocaleString('es-CO')}</Text>
                            </div>
                        </>
                    )}

                    {esVenta && documento.metodo_pago?.toLowerCase() === 'credito' && (
                        <div style={{ marginTop: '8px', borderTop: '1px dashed #cbd5e1', paddingTop: '8px' }}>
                            {Number(documento.efectivo_recibido) > 0 && (
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                                    <Text>ABONO INICIAL:</Text>
                                    <Text>${Number(documento.efectivo_recibido).toLocaleString('es-CO')}</Text>
                                </div>
                            )}
                            <div style={{ display: 'flex', justifyContent: 'space-between', color: '#cf1322', fontSize: '16px', background: '#fef2f2', padding: '4px', borderRadius: '4px' }}>
                                <Text strong style={{ color: '#cf1322' }}>SALDO PEND.:</Text>
                                <Text strong style={{ color: '#cf1322' }}>
                                    ${Number((documento.total || 0) - (documento.efectivo_recibido || 0)).toLocaleString('es-CO')}
                                </Text>
                            </div>
                        </div>
                    )}

                    {!esVenta && documento.motivo && (
                        <div style={{ marginTop: '8px', borderTop: '1px dashed #cbd5e1', paddingTop: '8px' }}>
                            <Text style={{ display: 'block', marginBottom: '2px' }}>MOTIVO:</Text>
                            <Text style={{ fontStyle: 'italic', color: '#475569' }}>"{documento.motivo}"</Text>
                        </div>
                    )}

                    {/* --- NUEVO: COMPROBANTE DE TRANSFERENCIA --- */}
                    {esVenta && documento.comprobante_url && (
                        <div style={{ marginTop: '12px', borderTop: '1px dashed #cbd5e1', paddingTop: '12px', textAlign: 'center' }}>
                            <Text strong style={{ display: 'block', marginBottom: '8px', fontSize: '11px' }}>SOPORTE DE TRANSFERENCIA:</Text>
                            <Image
                                src={documento.comprobante_url}
                                alt="Soporte"
                                style={{ maxHeight: '140px', objectFit: 'contain', borderRadius: '4px', border: '1px solid #e2e8f0' }}
                            />
                        </div>
                    )}
                </div>

                <div style={{ textAlign: 'center', marginTop: 15, fontSize: '10px', color: '#999' }}>
                    *** YUGONUB POS - GRACIAS ***
                </div>
            </div>
        </Modal>
    );
};

export default ModalDetalleDocumento;